module.exports = __webpack_public_path__ + "static/img/s10.4940316c.png";